import data from '@albacross/static-data/lib/data/countries.json'

export const findCountryByCode = (code?: string) => {
  const iso = code?.toUpperCase()
  return data.find(country => country.iso === iso)
}

export const getCountryMap = (by = 'iso') => countriesToMap(data, by)

export const countriesToMap = (countries, by = 'iso') => new Map(countries.map(c => [c[by], c]))
